<app-text [alias]="'course_list_registrar'"></app-text>
<mat-card>
    <mat-card-content>
        <app-table-filter [initialFilter]="initialFilter"
                          [tableName]="tableName"
                          [filterItems]="filters"
                          [mayExport]="true"
                          [trackExport]="true"
        ></app-table-filter>
    </mat-card-content>
</mat-card>
<app-table [tableName]="tableName" [searchCriteria]="criteria" [baseUrl]="baseUrl" [columns]="columns"></app-table>
